function Cinema_form_film(element) {
    this.$element = $(element);

    this.selectors = {
		FieldTrailerUrl: '#collection_trailer_url'
    };
    
    this.data = {
	    ajaxUrl: 'ajax-url',
	    pluginName: 'plugin-name'
    };
    
    this.init = function() {
		this.$fieldTrailerUrl = this.$element.find(this.selectors.FieldTrailerUrl);
	    this.$fieldTrailerUrl.on('blur', this.$onCopyPasteTrailerUrl.bind(this));
    };

    this.$onCopyPasteTrailerUrl = function (event) {
    	var embedBaseUrl = 'https://www.youtube.com/embed/';
		var url = this.$fieldTrailerUrl.val().trim();
		var parts = [];

		if (url != '') {
			// convert youtu.be url to embed url
			if (url.indexOf('youtu.be') !== -1) {
				parts = url.split(".be/");
				if (parts[1]) {
					url = embedBaseUrl + parts[1];
				}
			}

			// convert youtube.com/watch url to embed url
			if (url.indexOf('youtube.com/watch') !== -1) {
				parts = url.split("?v=");
				if (parts[1]) {
					url = embedBaseUrl + parts[1];
				}
			}
		}

		this.$fieldTrailerUrl.val(url);
	};
}
